import { render, staticRenderFns } from "./AppHistoricalMapOverlay.vue?vue&type=template&id=572d4c89&scoped=true&"
import script from "./AppHistoricalMapOverlay.vue?vue&type=script&lang=js&"
export * from "./AppHistoricalMapOverlay.vue?vue&type=script&lang=js&"
import style0 from "./AppHistoricalMapOverlay.vue?vue&type=style&index=0&id=572d4c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d4c89",
  null
  
)

export default component.exports